<template>

  <p>Error : page not found</p>

</template>

<script>

export default {
  name: 'NotFound'
}

</script>



// WEBPACK FOOTER //
// src/pages/NotFound.vue